import React from "react";
import { useParams } from "react-router-dom";
import { AppUtils } from "../../models/common/appUtils";
import { SalaryPeriodItem } from "../../models/salaryPeriod/salaryPeriodItem";
import { IWorkTimeDetailsPage } from "./workTimeBetaDetailsPageMain";
import { Chip, Stack, Typography } from "@mui/material";
import { Base } from "../../framework/base";
import { useSelectPaidWorkHoursAmountByDate } from "../../hooks/workTime/useSelectWorkHours";
import { useTranslation } from "react-i18next";

interface Props {
    selectedSalaryPeriodItem: SalaryPeriodItem;
}

export const WorkHoursPerSalaryPeriod: React.FC<Props> = ({
    selectedSalaryPeriodItem,
}) => {
    const { employeeId } = useParams<IWorkTimeDetailsPage>();
    const { t } = useTranslation();

    const salaryPeriodMinutes = useSelectPaidWorkHoursAmountByDate(
        employeeId,
        selectedSalaryPeriodItem?.startDate,
        selectedSalaryPeriodItem?.endDate
    );

    if (!selectedSalaryPeriodItem) {
        return null;
    }
    return (
        <Stack direction="row" gap={2} alignItems="center">
            <Typography variant="h4" className="selected-salary-period">
                {t("salaryPeriod")}:{" "}
                {Base.dayjsToDateStrShort(selectedSalaryPeriodItem.startDate)}-
                {Base.dayjsToDateStrShort(selectedSalaryPeriodItem.endDate)}
            </Typography>
            <Chip
                color="green"
                className="salary-period-total-hours"
                label={`${AppUtils.getDurationStrByDurationMinShort(
                    salaryPeriodMinutes,
                    true
                )} ${t("units.AbrHours")}`}
            />
        </Stack>
    );
};
